import React from "react";
import assets from "../../../../../assets/assets";
import { IconController } from "../../../../Scripts/ImgController";
const SelectPrimaryGenre = ({ genreInformation, primaryGenre, setPrimaryGenre, secondaryGenres, setGenreChanged }) => {
   const clickHandler = (genre) => {
      setPrimaryGenre(genre);
      const index = secondaryGenres.findIndex((object) => {
         return object.id === genre.id;
      });
      if (index > -1) {
         secondaryGenres.splice(index, 1);
      }
      setGenreChanged(true);
   };
   return (
      <div
         className="py-2 hover-effect"
         onClick={() => {
            clickHandler(genreInformation);
         }}
      >
         <div className="px-4 gap-2 flex flex-row items-center">
            {primaryGenre.id === genreInformation.id ? <IconController src={assets.svg.crownActive} className="w-5 h-5 cursor-pointer" /> : ""}
            <h5 className={`text-xs flex-1 ${primaryGenre.id === genreInformation.id ? "activeshde" : ""}`}>{genreInformation.name}</h5>
         </div>
      </div>
   );
};

export default SelectPrimaryGenre;
